import { useIntl } from 'react-intl';

export default function useTranslate() {
  const intl = useIntl();

  const t = (id) =>
    id && typeof id === 'string'
      ? intl.formatMessage({ id: id?.toUpperCase(), defaultMessage: id })
      : id;

  return t;
}
